import React from "react";

export default function PriorityVoice() {
  return <div>Priority Voice</div>;
}